export const BASE_URL = 'https://121.157.24.40:5300/';

export const API_FILE = Object.freeze({
  FILE: 'file/',
  KEYWORD: 'file/search',
  CACHE: 'file/insert',
  UPLOAD: 'file/upload',
});

export const API_AUTH = Object.freeze({
  LOGIN: 'auth/login',
  SIGNUP: 'auth/signup',
});

export const API_PROFILE = Object.freeze({
  PROFILE: 'profile/',
});
